export default "__VITE_ASSET__zcfD4XWf__"